<script setup lang="ts">
// import "@zyzgroup/core-web/dist/css/better.css";
// import "@zyzgroup/core-web/dist/css/theme.css";
// import "@zyzgroup/core-web/dist/css/font.css";

import "@zyzgroup/core-web/dist/css/rem_750.css";
import {
  FeRouteDirection,
  setRem,
  SupportedEaseNameToCubicBezier
} from "@zyzgroup/core-web";

import {
  provide,
  onUnmounted,
  ref,
  shallowRef,
  reactive,
  shallowReactive
} from "vue";
import type { Component } from "vue";
import {
  context,
  ContextEventBusListeners,
  Context,
  mapState
} from "../../context/context";

import {
  RouterView,
  getCurrentRouteDetail,
  routeChange$
} from "../../hooks/useVueRouter";
import Page from "./Page.vue";
import { CSSAnimationName } from "@zyzgroup/core-common";

// import ResizeObserver from "./components/base/ResizeObserver.vue";
// import FPSStats from "../fps/FPSStats.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    designWidth?: number;
  }>(),
  {
    designWidth: 750
  }
);

// import(
//   /* @vite-ignore */ `@zyzgroup/core-web/dist/rem_${props.designWidth}.css`
// );
setRem(props.designWidth);

// const layout = ref(document.documentElement.dataset.layout);

provide<Context<ContextEventBusListeners>>("context", context);
// const context = inject<Context<ContextEventBusListeners>>("context");
// const context = inject<Context>("context");

// const app = inject("app", null) as unknown as App<Element>;

const mappedState = mapState(["color.panelPattern", "color.fontPattern"]);

// const resize = (size: { width: number; height: number }) => {
//   context.eb.emit("globalResize", size.width, size.height);
// };

const RouteComboEffecs: Record<
  string,
  Record<
    "prev" | "next",
    {
      name: CSSAnimationName;
      timingFunction: SupportedEaseNameToCubicBezier;
      duration: number;
      delay: number;
      top?: (direction: FeRouteDirection) => -1 | 1;
    }
  >
> = {
  moveToLeft: {
    prev: {
      name: "moveToLeft",
      timingFunction: "ease-out",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromRight",
      timingFunction: "ease-out",
      duration: 300,
      delay: 0
    }
  },
  moveToRight: {
    prev: {
      name: "moveToRight",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromLeft",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToTop: {
    prev: {
      name: "moveToTop",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromBottom",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToBottom: {
    prev: {
      name: "moveToBottom",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromTop",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveFromLeftPrevFade: {
    prev: {
      name: "fade",
      timingFunction: "linear",
      duration: 300,
      delay: 0,
      top: (direction: FeRouteDirection) => (direction == "forward" ? -1 : 1)
    },
    next: {
      name: "moveFromLeft",
      timingFunction: "linear",
      duration: 300,
      delay: 0,
      top: (direction: FeRouteDirection) => (direction == "forward" ? 1 : -1)
    }
  },
  moveFromRightPrevFade: {
    prev: {
      name: "fade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromRight",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveFromTopPrevFade: {
    prev: {
      name: "fade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromTop",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveFromBottomPrevFade: {
    prev: {
      name: "fade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromBottom",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToLeftFade: {
    prev: {
      name: "moveToLeftFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromRightFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToRightFade: {
    prev: {
      name: "moveToRightFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromLeftFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToTopFade: {
    prev: {
      name: "moveToTopFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromBottomFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToBottomFade: {
    prev: {
      name: "moveToBottomFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromTopFade",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  },
  moveToLeftEasing: {
    prev: {
      name: "moveToLeft",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    },
    next: {
      name: "moveFromRight",
      timingFunction: "linear",
      duration: 300,
      delay: 0
    }
  }
};

const comboEffect = RouteComboEffecs["moveToLeft"];

const pages = shallowReactive<
  {
    fullPath: string;
    component: Component;
    props: Record<string, any>;
  }[]
>([]);
const refs = [];

let direction = "keep";
const fromIndex = ref(-1);
const toIndex = ref(-1);

let forwardNewPageAction = null;

const rs$ = routeChange$.subscribe(([newRoute, oldRoute, route, history]) => {
  // console.log("Root: ", newRoute, oldRoute, route, history);
  const foundNewIndex = pages.findIndex((p) => p.fullPath == newRoute.fullPath);
  const foundOldIndex = pages.findIndex((p) => p.fullPath == oldRoute.fullPath);
  direction = route.direction;
  switch (route.direction) {
    case "keep":
      const keepIndex =
        foundNewIndex >= 0
          ? foundNewIndex
          : foundOldIndex >= 0
          ? foundOldIndex
          : -1;
      if (keepIndex < 0) {
        pages.push({
          fullPath: newRoute.fullPath,
          component: newRoute.component,
          props: newRoute.props
        });
      }
      fromIndex.value = -1;
      toIndex.value = keepIndex >= 0 ? keepIndex : pages.length - 1;
      break;
    case "forward":
      if (foundOldIndex < 0) {
        pages.push({
          fullPath: oldRoute.fullPath,
          component: oldRoute.component,
          props: oldRoute.props
        });
        fromIndex.value = pages.length - 1;
      } else {
        fromIndex.value = foundOldIndex;
      }
      if (foundNewIndex < 0) {
        // 与浏览器行为保持一致：删除部分记录
        pages.splice(fromIndex.value + 1);
        pages.push({
          fullPath: newRoute.fullPath,
          component: newRoute.component,
          props: newRoute.props
        });
        // 只添加新数据
        toIndex.value = -1;
        refs[fromIndex.value]?.open(comboEffect.prev);
        forwardNewPageAction = () => {
          // 开启动画
          toIndex.value = pages.length - 1;
          refs[toIndex.value]?.open(comboEffect.next);
        };
      } else {
        toIndex.value = foundNewIndex;
        refs[fromIndex.value]?.open(comboEffect.prev);
        refs[toIndex.value]?.open(comboEffect.next);
      }
      break;
    case "backward":
      if (foundOldIndex < 0) {
        pages.push({
          fullPath: oldRoute.fullPath,
          component: oldRoute.component,
          props: oldRoute.props
        });
        fromIndex.value = pages.length - 1;
      } else {
        fromIndex.value = foundOldIndex;
      }
      if (foundNewIndex < 0) {
        const newIndex = Math.max(fromIndex.value - 1, 0);
        pages.splice(newIndex, 0, {
          fullPath: newRoute.fullPath,
          component: newRoute.component,
          props: newRoute.props
        });
        toIndex.value = newIndex;
      } else {
        toIndex.value = foundNewIndex;
      }
      refs[fromIndex.value]?.close(comboEffect.next);
      refs[toIndex.value]?.close(comboEffect.prev);
      break;
  }
  // console.log("pages: ", pages);
});

function getDynamicZIndex(index: number): number {
  const defaulZIndex = 1;
  const lowerZIndex = 2;
  const higherZIndex = 3;
  // console.log("*******");
  // console.log(...pages);
  // console.log("current index: ", index);
  // console.log("direction: ", direction);
  // console.log("from index: ", fromIndex.value);
  // console.log("to index: ", toIndex.value);
  let resultIndex = defaulZIndex;
  switch (direction) {
    case "keep":
      break;
    case "forward":
      if (index == fromIndex.value) {
        resultIndex = comboEffect.prev.top
          ? comboEffect.prev.top(direction) > 0
            ? higherZIndex
            : lowerZIndex
          : defaulZIndex;
      }
      if (index == toIndex.value) {
        resultIndex = comboEffect.next.top
          ? comboEffect.next.top(direction) > 0
            ? higherZIndex
            : lowerZIndex
          : defaulZIndex;
      }
      break;
    case "backward":
      if (index == fromIndex.value) {
        resultIndex = comboEffect.next.top
          ? comboEffect.next.top(direction) > 0
            ? higherZIndex
            : lowerZIndex
          : defaulZIndex;
      }
      if (index == toIndex.value) {
        resultIndex = comboEffect.prev.top
          ? comboEffect.prev.top(direction) > 0
            ? higherZIndex
            : lowerZIndex
          : defaulZIndex;
      }
      break;
  }
  // console.log("resultIndex: ", resultIndex);
  return resultIndex;
}

function resetNewPage() {
  // 同一祖先下，如果有多个Page，可能会出错
  context.ds.clear();
}

function dismissOldPage() {
  fromIndex.value = -1;
}

const pageOpenStart = () => {
  // console.log("pageOpenStart");
  resetNewPage();
  forwardNewPageAction?.();
  forwardNewPageAction = null;
};
const pageOpenEnd = () => {
  // console.log("pageOpenEnd");
  dismissOldPage();
};
const pageCloseStart = () => {
  // console.log("pageCloseStart");
  resetNewPage();
};
const pageCloseEnd = () => {
  // console.log("pageCloseEnd");
  dismissOldPage();
};

onUnmounted(() => {
  rs$.unsubscribe();
});

defineExpose({});
</script>

<template>
  <div
    class="root"
    style="
      position: relative;
      width: 100%;
      width: 100vw;
      height: 100%;
      height: 100vh;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
    "
    :style="{
      backgroundColor: `${mappedState['color.panelPattern'].value}`,
      color: `${mappedState['color.fontPattern'].value}`
    }"
  >
    <!-- <KeepAlive> 是一个内置组件，它的功能是在多个组件间动态切换时缓存被移除的组件实例 -->
    <!-- 它会根据组件的 name 选项进行匹配，所以组件如果想要条件性地被 KeepAlive 缓存，就必须显式声明一个 name 选项 -->
    <!-- include="a,b" :include="/a|b/" :include="['a', 'b']" -->
    <!-- exclude="a,b" :exclude="/a|b/" :exclude="['a', 'b']" -->
    <!-- 限制可被缓存的最大组件实例数 :max="10" -->
    <!--
  <KeepAlive>
    <Suspense>
      <component :is="Component"></component>
      <template #fallback>正在加载...</template>
    </Suspense>
  </KeepAlive>
  -->

    <!--
      Vue Router 使用动态导入对懒加载组件进行了内置支持。
      这些与异步组件不同，目前他们不会触发 <Suspense>。
      但是，它们仍然可以有异步组件作为后代，这些组件可以照常触发 <Suspense>。
    -->
    <!-- <RouterView v-slot="{ Component, route }">
      <KeepAlive>
        <component
          :is="Component"
          v-bind="getCurrentRouteDetail(route).props"
        ></component>
      </KeepAlive>
    </RouterView> -->

    <!-- 自定义 <RouterView> -->
    <Page
      v-for="(page, index) in pages"
      v-show="fromIndex == index || toIndex == index"
      :ref="(el) => (refs[index] = el)"
      @pageOpenStart="pageOpenStart"
      @pageOpenEnd="pageOpenEnd"
      @pageCloseStart="pageCloseStart"
      @pageCloseEnd="pageCloseEnd"
      :style="{
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: getDynamicZIndex(index)
      }"
    >
      <KeepAlive>
        <component
          :is="page.component"
          v-bind="page.props"
        ></component>
      </KeepAlive>
    </Page>

    <!-- <ResizeObserver @resize="resize"></ResizeObserver> -->
    <!-- <FPSStats></FPSStats> -->
  </div>
</template>

<style>
/* for ce */
/* index.html 全局加载：@import "@zyzgroup/core-web/dist/css/better.css"; */
/* index.html 全局加载：@import "@zyzgroup/core-web/dist/css/theme.css"; */
/* index.html 全局加载：@import "@zyzgroup/core-web/dist/css/font.css"; */

/* for ce ： 在上方<script>内引入 */
/* @import "@zyzgroup/core-web/dist/rem_750.css"; */
</style>
